
import { Vue, Component } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import BarcodeOrderModule from "@/store/modules/barcodeSystem/barcodeOrder";
import notifications from "@/lib/notifications";
import { BarcodeOrderListFilters } from "@/models/api/barcodeSystem/barcodeOrders/get";
import BarcodeSystemModule from "@/store/modules/barcodeSystem";

const barcodeOrderModuleState = getModule(BarcodeOrderModule);
const barcodeSystemModuleState = getModule(BarcodeSystemModule);

@Component
export default class BarcodeOrderFilters extends Vue {
  localFilters: BarcodeOrderListFilters = null;

  get filters() {
    return barcodeOrderModuleState.filters;
  }

  created() {
    this.localFilters = JSON.parse(JSON.stringify(this.filters));
  }

  async submit() {
    barcodeOrderModuleState.setFilters(JSON.parse(JSON.stringify(this.localFilters)));
    barcodeOrderModuleState.setLoading(true);
    try {
      await barcodeOrderModuleState.getBarcodeOrders({
        pageNumber: 1,
        pageSize: barcodeOrderModuleState.pageData.pageSize
      });
    } catch (ex) {
      notifications.error("Loading Orders", "Failed to load barcode orders", ex);
    }

    barcodeOrderModuleState.setLoading(false);
  }

  get currentFacilityCode(): string {
    return barcodeSystemModuleState.currentFacilityCode;
  }

  get loading(): boolean {
    return barcodeOrderModuleState.loading;
  }

  getBooleanOptions() {
    return [
      { label: "", value: null },
      { label: "Yes", value: true },
      { label: "No", value: false }
    ];
  }
}
